import { toast } from 'react-toastify';
import { HttpError } from './http';

export function onSuccess(message: string) {
  toast(message, { type: 'success' });
}

export function onWarning(e: unknown) {
  console.warn(e);
}

export function onError(e: unknown, additionalMessage = '') {
  errorHandler(additionalMessage)(e);
}

export function errorHandler(
  additionalMessage = '',
  { type = 'error', autoClose: autoCloseOpt }: Options = {},
) {
  return (e: unknown) => {
    const autoClose = (autoCloseOpt ?? type === 'error') ? false : 10_000;

    let message = [additionalMessage, toError(e).message]
      .filter(Boolean)
      .join('. ');

    if (e instanceof HttpError) {
      message += ' [API]';
    }

    console[type](additionalMessage, e);
    toast(message, { type: type === 'warn' ? 'warning' : 'error', autoClose });
  };
}

export function toError(e: unknown): Error {
  if (e instanceof Error) {
    return e;
  }

  if (typeof e === 'string') {
    return new Error(e);
  }

  return new Error(JSON.stringify(e) || 'Unknown error');
}

interface Options {
  autoClose?: false | number;
  type?: 'error' | 'warn';
}
